<script setup lang="ts">
import { computed } from 'vue-demi'

export interface TelephoneNumber {
  tel: string
}
const props = defineProps<TelephoneNumber>()

// remove whitespaces from number
const telClean = computed(() => props.tel.replace(/\s/g, ''))
</script>

<template>
  <a :href="`tel:${telClean}`">{{ tel }}</a>
</template>

<style scoped>

</style>
